const modalTypes = {
	OPEN_LOG_MODAL: 'OPEN_LOG_MODAL',
	CLOSE_LOG_MODAL: 'CLOSE_LOG_MODAL',
	TOGGLE_LOG_MODAL: 'TOGGLE_LOG_MODAL',
	SHOW_SIGN_UP_ONLY: 'SHOW_SIGN_UP_ONLY',
	SHOW_SIGN_IN_ONLY: 'SHOW_SIGN_IN_ONLY',
};

export default modalTypes;
